import React, { useState } from 'react';
import Overlay from 'core/components/Overlay';
import Spinner from 'core/components/Spinner';
import { FlexCol } from 'core/styles';

// Center & prevent background click-to-dismiss for most of canvas
const colStyles = {
	width: 'calc(100vw - 40px)',
	height: 'calc(100vh - 40px)',
	justifyContent: 'center',
};

const OverlaySpinner = (props) => {
	const [open, setOpen] = useState(true);
	if (!open) return null;
	return (
		<Overlay noOverflow dismiss={() => setOpen(false)}>
			<FlexCol centered style={colStyles}>
				Loading...<br />
				<Spinner {...props} />
			</FlexCol>
		</Overlay>
	);
};

export default OverlaySpinner;
